module.exports = __webpack_public_path__ + "static/img/product-loanuse.df859eff.png";